import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/wimberley")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Wimberley, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Wimberley & Hays County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Wimberley, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Wimberley and Hays County.",
      keywords: "awnings Wimberley, awning company Wimberley, custom awnings Wimberley, sail shades Wimberley, patio covers Wimberley, pergola covers Wimberley, metal awnings Wimberley, canvas awnings Wimberley, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Wimberley", "Hays County"),
  }),
  component: () => <CityHomePage city="Wimberley" region="Hays County" />,
});
